import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doLogout: UseCase<AuthRepository, 'logout'> = (repository) => {
  return async () => {
    await repository.logout()
  }
}
